<template>
    <div class="category_filter_items">

        <div v-for="(item) in items" :key="item.id"
             class="category_filter_item"
             @click="goToCategory(item)"
        >
            {{ item.name }}
        </div>

    </div>
</template>

<script>

    import api from "../../api";

    export default {
        name: "ShopCategoryFilter",
        data() {
            return {
                categories: null,
            }
        },
        created() {
            this.loadCategories();
        },
        computed: {
            items: function () {
                return this.$route.params.categoryId !== undefined ? this.categories : this.$store.getters.shopMainCategories
            }
        },
        methods: {
            async loadCategories() {
                let categoryId = this.$route.params.categoryId
                let scheduleId = this.$route.params.scheduleId;

                if (categoryId === undefined){
                    if (this.$store.getters.shopMainCategories.length === 0){
                        this.$store.dispatch('loadShopMainCategories', scheduleId)
                    }
                } else {
                    this.categories = (await api.shop.getCategories({
                        params: {
                            id: categoryId,
                            schedule_id: scheduleId
                        }
                    })).data.items;
                }
            },
            goToCategory(item) {
              const scheduleId = this.$route.params.scheduleId;

              if (scheduleId) {
                this.$router.push({
                  name: 'ShopScheduleCategory',
                  params: {
                    scheduleId: scheduleId,
                    categoryId: item.id
                  },
                  query: {
                    categoryName: item.name
                  }
                });
              } else {
                this.$router.push({
                  name: 'ShopCategory',
                  params: {
                    categoryId: item.id,
                  },
                  query: {
                    categoryName: item.name
                  }
                });
              }
            },
        },
    }
</script>